export class Fornecedor {
  codigoFornecedor: string;
  nomeFornecedor: string;
  cnpjFornecedor: string;
  cpfFornecedor: string;
  codigoGrupoContaFornecedor: string;
  inWhiteList: boolean;
  dataFixa: boolean;

  status: string;
  mensagem: string;
}

